import { EnvironmentProviders, inject, makeEnvironmentProviders, provideEnvironmentInitializer } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { AssetsHelper } from '@/helpers/assetsHelper';
import { EEMO_ICON_KEY } from './enums/eemo-icon.enums';

export const ICONS = {
  NOTE: 'sticky_note_2',
  CREATE: 'add',
  CREATE_HIGHLIGHT: 'add_circle',
  EDIT: 'edit',
};

// enregistre les icônes SVG EEMO dans MatIconRegistry au démarrage
export function provideEemoIcons(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideEnvironmentInitializer(() => {
      const iconRegistry = inject(MatIconRegistry);
      const sanitizer = inject(DomSanitizer);
      iconRegistry.addSvgIcon(EEMO_ICON_KEY.EEMO, sanitizer.bypassSecurityTrustResourceUrl(AssetsHelper.eemoIcon));
      iconRegistry.addSvgIcon(EEMO_ICON_KEY.SEND, sanitizer.bypassSecurityTrustResourceUrl(AssetsHelper.sendIcon));
    }),
  ]);
}
